import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from './firestore.service';
import type { TPickupRequest } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class PickupRequestsService {
    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getObservable(): Observable<TPickupRequest[]> {
        // I think I shouldn't pass in the shuttleUid.
        // The observable watches the collection for any changes not a specific document.
        const path = this.firestorePathsService.getPickupRequestsPath();
        const observable = this.firestoreService.getObservable(path) as Observable<TPickupRequest[]>;
        return observable;  
    }

    public getAll(): Promise<TPickupRequest[]> {
        const path = this.firestorePathsService.getPickupRequestsPath();
        return this.firestoreService.getAll(path) as Promise<TPickupRequest[]>;
    }

    public add(shuttleUid: string, request: TPickupRequest): Promise<TPickupRequest> {
        const path = this.firestorePathsService.getPickupRequestsPath();
        return this.firestoreService.add(path, request);
    }

    public async set(request: TPickupRequest) {
        const path = this.firestorePathsService.getPickupRequestsPath();
        await this.firestoreService.set(path, request);
    }

    public update(shuttleUid: string, request: TPickupRequest): Promise<TPickupRequest> {
        const path = this.firestorePathsService.getPickupRequestsPath();
        return this.firestoreService.update(path, request);
    }

    public delete(requestUid): Promise<void> {
        const path = this.firestorePathsService.getPickupRequestsPath();
        return this.firestoreService.delete(path, requestUid);
    }

    // public async deleteAll(shuttleUid) {
    //     const requests = await this.getAll();
    //     requests.forEach((request) => {
    //         this.delete(request.uid);
    //     });
    // }

    // public getSingle(): any {
    //     return super.getSingle(ref);
    // }

    // ptb public getProfile(accountNumber: string) {
    //     const col = this.firestorePathsService.getAccountsRef().child(accountNumber + '/accountProfile');
    //     return super.getSingle(ref);
    // }

    public async deleteOld(shuttleUid, milliSecs): Promise<number> {
        // console.log('Type mismatch');
        return new Promise((resolve) => resolve(0));
        // #type-mismatch
        // let count = 0;
        // const cutoffTime = Date.now() - milliSecs;

        // const items = await this.getAll();
        // items.forEach(async (item) => {
        //     if (item.createdDate < cutoffTime) {
        //         await this.delete(item.uid);
        //         ++count;
        //     }
        // });
        // return count;
    }
}
